import './LeadsSummaryTasks.css';
import { calculateDaysBetween } from '../../utilities/services/calculateDaysBetween';
import LeadsSummaryTasksItem from '../LeadsSummaryTasksItem/LeadsSummaryTasksItem';

export default function LeadsSummaryTasks({taskList}) {
    const today = new Date()
    const warningDays = 3
  return (
    <div className='LeadsSummaryTasks'>
        <div className='tasksBody'>
            { taskList.length>0 &&
            <div className='header'>
                <div className='taskOwner'>Lead</div>
                <div className='taskTitle'>Task</div>
                <div className='taskPriority'>Priority</div>
                <div className='taskDeadline'>Deadline</div>
                <div className='assignedTo'>Assignee</div>
            </div>
            }
            <div className="tasksItems">
                { !(taskList.length > 0) ?
                    <div className='noTasks'>No Pending Tasks</div>
                :
                <>
                { taskList.map((task, idx) => (
                    <LeadsSummaryTasksItem key={idx} task={task} backgroundStyle={(today > new Date(task.deadline)) ? 'overdue' : (calculateDaysBetween(today, task.deadline) <= warningDays) ? 'deadlineWarning' : 'upcoming'} />
                ))}
                </>
                }
            </div>
        </div>
    </div>
  )
}
